export default {
    install: (app) => {
        app.config.globalProperties.$route = (name, params = {}) => {
            let route = window.routes;

            name.split('.').forEach((segment) => {
                route = route[segment];
            });
            return route;
        };
    }
};